;(function() {
"use strict";

angular.module('core.Backoff', [])
  .factory('Backoff', BackoffFactory);

/**
 * Provides simple exponential backoff execution, tailored for angularjs
 * Inspired by https://github.com/segmentio/backo
 */
BackoffFactory.$inject = ['$q', '$timeout'];
function BackoffFactory($q, $timeout) {
  function Backoff(opts = {}) {
    this.interval = opts.interval || 1000;
    this.maxInterval = opts.maxInterval || 10000;
    this.factor = opts.factor || 2;
    this.attempts = 0;
    this.maxAttempts = opts.maxAttempts || 10;
    this.done = $q.defer();
    this.timer = null;
  }

  /**
   * Calculate the duration of the next backoff interval
   * @returns {number} duration in milliseconds
   */
  Backoff.prototype.duration = function () {
    const interval = this.interval * (this.factor ** this.attempts);
    this.attempts += 1;
    return Math.floor(Math.min(interval, this.maxInterval));
  };

  /**
   * Execute and backoff a callable
   * @param fn
   * @returns {*|Deferred|{resolve, reject, promise}}
   *          Resolved if execution is stopped normally
   *          Rejected if execution reaches the maximum number of attempts
   */
  Backoff.prototype.exec = function (fn) {
    if (this.attempts < this.maxAttempts) {
      const self = this;
      this.timer = $timeout(() => {
        fn();
        self.exec(fn);
      }, this.duration());
    } else {
      this.stop(true);
    }
    return this.done.promise;
  };

  /**
   * Stops execution (if applicable) and resets the state for reuse
   * @param reject - whether to reject or resolve the "done" promise
   */
  Backoff.prototype.stop = function (reject) {
    this.attempts = 0;
    const error = new Error('[Backoff] Max attempts reached');
    (reject ? this.done.reject.bind(null, error) : this.done.resolve)();
    this.done = $q.defer();
    if (this.timer) {
      $timeout.cancel(this.timer);
      this.timer = null;
    }
  };

  return Backoff;
}
}());
